module.exports = __webpack_public_path__ + "img/39.11d10bce.png";